import {NgModule} from '@angular/core'
import {RouterModule, Routes} from '@angular/router'
import {FolderDashboardComponent} from './folder-dashboard/folder-dashboard.component'
import {FolderViewComponent} from './folder-view/folder-view.component'
import {FolderComponent} from './folder.component'
import {FolderAddComponent} from './folder-add/folder-add.component'
import {FolderRenameComponent} from './folder-rename/folder-rename.component'
import {FolderEditComponent} from './folder-edit/folder-edit.component'
import {FolderUploadComponent} from './folder-upload/folder-upload.component'
import {FolderVersionComponent} from './folder-version/folder-version.component'

const ROUTES: Routes = [
  // {
  //   path: 'dashboard',
  //   component: FolderDashboardComponent,
  // },
  {
    path: 'f/:customURL',
    component: FolderComponent,
    children: [
      {
        path: '',
        component: FolderViewComponent,
        pathMatch: 'full',
        data: {current_component: 'view'},
      },
    ],
  },
  {
    path: 'folder/:folderId',
    component: FolderComponent,
    children: [
      {
        path: '',
        component: FolderViewComponent,
        pathMatch: 'full',
        data: {current_component: 'view'},
      },
      {
        path: 'add',
        component: FolderAddComponent,
        data: {current_component: 'add'},
      },
      {
        path: 'rename',
        component: FolderRenameComponent,
        data: {current_component: 'rename'},
      },
      {
        path: 'edit',
        component: FolderEditComponent,
        data: {current_component: 'edit'},
      },
      {
        path: 'upload',
        component: FolderUploadComponent,
        data: {current_component: 'upload'},
      },
      {
        path: 'version/:fileId',
        component: FolderVersionComponent,
        data: {current_component: 'version'},
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
  exports: [RouterModule],
})
export class FolderRoutingModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-routing.module.ts